import { IPkgTransInput } from "../pages/page-components/pacakges/PkgTranslationForm";
import { PkgInputs } from "../pages/page-components/pacakges/TabAddPackages";
import httpUtil from "../utils/http.util";

class PkgService {
  async createPkg(data: PkgInputs) {
    return await httpUtil.post("/package/create", data, true);
  }

  async createTranslation(data: IPkgTransInput) {
    return await httpUtil.post("/package/translate/create", data);
  }

  async fetchTranslation(pkg_id: string, lang_id: string) {
    return await httpUtil.get(
      `/package/translate/getOne?pkg=${pkg_id}&lang=${lang_id}`
    );
  }

  async updateTranslation(translationId: string, data: IPkgTransInput) {
    return await httpUtil.patch(
      "/package/translate/update",
      translationId,
      data
    );
  }

  async AllPkges() {
    return await httpUtil.get("/package/getAll");
  }

  async PkgDetail(pkgId: string, lang_id: string) {
    return await httpUtil.get(`/package/pkgDetail/${pkgId}?lang=${lang_id}`);
  }

  async updatePkg(id: string, data: PkgInputs) {
    return await httpUtil.put(`/package/update`, id, data, true);
  }

  async deletePkg(id: string) {
    return await httpUtil.delete(`/package/delete`, id);
  }
}

export default new PkgService();
